import { Button, Card, Form, InputNumber, Select, Space } from 'antd';
import React, { useEffect, useState } from 'react';

import { EditEdutainmentModal } from '../EditEdutainmentModal';
import { INIT_RULES_FORM_VALUES, TIME_UNIT_OPTIONS } from './constants';
import { getRefundPolicyText } from './helpers';
import styles from './index.module.scss';
import type { ApplicationRulesFormValues } from './types';

const { Item, useForm } = Form;

export const ApplicationRules = () => {
  const [form] = useForm<ApplicationRulesFormValues>();

  const [isEditingRules, setIsEditingRules] = useState(false);
  const [openEditEdutainmentModal, setOpenEditEdutainmentModal] =
    useState(false);

  // TODO: 暫時用這個，到時候串接API後再看看是否還需要用state來拿值
  const [refundPolicyText, setRefundPolicyText] = useState('');

  useEffect(() => {
    const cancelReservation = form.getFieldValue('cancelReservation');
    const refundPolicy = getRefundPolicyText(cancelReservation);
    if (refundPolicyText !== refundPolicy) {
      setRefundPolicyText(refundPolicy);
    }
  }, [form, refundPolicyText]);

  const onFormFinish = (formValues: ApplicationRulesFormValues) => {
    console.log('formValues:', formValues);
  };

  const cancelEditing = () => {
    form.resetFields();
    setIsEditingRules(false);
  };

  return (
    <Space direction="vertical" className={styles['w-full']}>
      <Button onClick={() => setOpenEditEdutainmentModal(true)}>
        新增育樂活動
      </Button>
      <EditEdutainmentModal
        open={openEditEdutainmentModal}
        closeEditModal={() => setOpenEditEdutainmentModal(false)}
        refundPolicy={refundPolicyText}
      />
      <Card>
        <Form
          form={form}
          onFinish={onFormFinish}
          layout="vertical"
          initialValues={INIT_RULES_FORM_VALUES}
        >
          <Space direction="vertical" className={styles['w-full']}>
            <h5 className={styles.title}>育樂活動預約管理辦法</h5>
            <Space align="baseline">
              <p>1.活動開始前</p>
              <Item
                name={['cancelReservation', 'number']}
                rules={[{ required: true, message: '必填欄位' }]}
              >
                <InputNumber
                  className={styles.inputNumber}
                  min={1}
                  step={1}
                  placeholder="請輸入數字"
                  precision={0}
                  disabled={!isEditingRules}
                />
              </Item>
              <Item
                name={['cancelReservation', 'unit']}
                rules={[{ required: true, message: '必填欄位' }]}
              >
                <Select
                  options={TIME_UNIT_OPTIONS}
                  placeholder="請選擇時間單位"
                  disabled={!isEditingRules}
                />
              </Item>
              <p>可取消預約，並全額退費。</p>
            </Space>
            <Space align="baseline">
              <p>2.活動報名開始前</p>
              <Item
                name={['reviewExpiration', 'number']}
                rules={[{ required: true, message: '必填欄位' }]}
              >
                <InputNumber
                  className={styles.inputNumber}
                  min={1}
                  step={1}
                  placeholder="請輸入數字"
                  precision={0}
                  disabled={!isEditingRules}
                />
              </Item>
              <Item
                name={['reviewExpiration', 'unit']}
                rules={[{ required: true, message: '必填欄位' }]}
              >
                <Select
                  options={TIME_UNIT_OPTIONS}
                  placeholder="請選擇時間單位"
                  disabled={!isEditingRules}
                />
              </Item>
              <p>為審核截止日期。</p>
            </Space>
            <div className={styles.actionButtons}>
              {isEditingRules ? (
                <Button onClick={cancelEditing}>取消</Button>
              ) : (
                <Button>發佈公告</Button>
              )}
              {isEditingRules ? (
                <Button htmlType="submit" type="primary">
                  完成
                </Button>
              ) : (
                <Button
                  type="primary"
                  onClick={(e) => {
                    e.preventDefault();
                    setIsEditingRules(true);
                  }}
                >
                  編輯
                </Button>
              )}
            </div>
          </Space>
        </Form>
      </Card>
    </Space>
  );
};
